import { AfterViewInit, Component, QueryList, ViewChild, ViewChildren, Renderer2, Inject, HostListener, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchRequest } from 'src/app/models/requests/searchRequest';
import { ExpansionPanelComponent } from 'src/app/shared/components/expansion-panel/expansion-panel.component';
import { SearchFieldComponent } from 'src/app/shared/components/search-field/search-field.component';
import { DataService } from 'src/app/shared/services/data.service';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { environment } from 'src/environments/environment'; 
import { DOCUMENT } from '@angular/common';
import { CareerPageData, CareerPositionsSorting } from './career-lobby-page.interfaces';
declare var window:any;

@Component({
  selector: 'app-career-lobby-page',
  templateUrl: './career-lobby-page.component.html',
  styleUrls: ['./career-lobby-page.component.scss', './career-lobby-page.component.en.scss'],
})
export class CareerLobbyPageComponent {
  @Input() pageUrl: string | unknown; 
  // For checking if some filtered was written
  @ViewChildren(ExpansionPanelComponent) expansionComponents: QueryList<ExpansionPanelComponent> = new QueryList<ExpansionPanelComponent>();
  // For scrolling when page was changed
  @ViewChild(SearchFieldComponent) searchFieldComponent?: SearchFieldComponent;
  // Current page data
  careerPageData?: CareerPageData;
  currentPage: number = 1;
  filters?: string;
  term: string = '';
  isMobile: boolean = false;
  showFiltersMobileModal: boolean = false;
  isLoading: boolean = false;
  sorting: CareerPositionsSorting=CareerPositionsSorting.UpdateDate;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private routerService: RouterService,
    private renderer: Renderer2, 
    @Inject(DOCUMENT) private document: Document,
    private userAgentService: UserAgentService
  ) { 
    this.isMobile = this.userAgentService.isMobileDevice();
  }

  ngOnInit() {
    let element = this.document.querySelector('.page-content');
    if(element) this.renderer.setStyle(element, 'padding', 'inherit');

    // handle url parameters on init
    this.handelUrlParameters();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    let width = (event.target as Window).innerWidth;
    this.isMobile = width <= 1300;
  }

  onFilterStatusChange(checked: boolean, filter: any) {
    filter.selected = checked;
    this.filters = '';
    let selectedFilterGroups: string[] = [];

    this.careerPageData!.filters.forEach((filterGroup: any) => {
      let selectedFilters = filterGroup.filters.filter((f: any) => {
        // if filter name was written in search bar -> delete search query from params
        if (f.filterDisplayText === this.term) this.onSearchInputChange('');
        return f.selected;
      });
      if (selectedFilters.length > 0) {
        selectedFilters
          .map((filter: any) => filter.filterKey)
          .forEach((key: any) => selectedFilterGroups.push(key));
      }
    });
    if (selectedFilterGroups.length > 0)
      this.filters = selectedFilterGroups.join(',');

    this.currentPage = 1;
    this.updateUrlParameters();
    this.getSearchResult();
  }

  onPageChange(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.searchFieldComponent?.scrollToSearchForm();
    this.updateUrlParameters();
    this.getSearchResult();
  }

  onSortingChange(value: CareerPositionsSorting) {
    if(this.sorting === value)
      return;
    this.sorting = value;
    this.currentPage = 1;
    this.updateUrlParameters();
    this.getSearchResult();
  }

  onSearchInputChange(searchQuery: string) {
    this.term = searchQuery;
    this.updateUrlParameters();
  }

  onSearchInputSubmit(value: string | undefined | { key: string, value: string, isFilterValue: boolean,isItemValue:boolean }) {
   if(typeof value === 'undefined')
    {
      this.currentPage = 1;
      this.getSearchResult();
      return
    }

    if(typeof value === 'string') {
     
      this.onSearchInputChange('');
      this.expansionComponents.forEach((c) => {
        c.checkMatchedFilterTypeString(value.toString());
      });
      this.currentPage = 1;
      return;
    }
    //if submit value of item from the list
    if(value.isItemValue){
    this.term=value.key;
    this.filters='';
    this.clearFilters();
     return
    }
    //this.openPositionPopup((value as any).value);
  }

  // openPositionPopup(positionId: string | number | undefined) {
  //   if(typeof positionId === 'undefined')
  //     return;
  //   positionId = typeof positionId === 'string' ? parseInt(positionId, 10) : positionId;
  //   window.CareerPositionPopUpHandler.openPopup(positionId)
  // }

  private getPageData() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Career-Api/Index';
    const searchRequest: SearchRequest = {
      pageUrl: this.pageUrl ?? this.routerService.getCurrentComponentRoute(),
      cultureCode: this.dataService.getCultureCode(),
      term: this.term,
      filters: this.filters,
      pageNumber: this.currentPage,
      sorting: this.sorting
    };

    this.dataService.getPortalPageData(url, searchRequest).subscribe({
      next: (data) => {
        this.careerPageData = JSON.parse(data);

        if(this.filters && this.careerPageData!.filters.length) {
          let selecteFilters = this.filters.split(',').map(String);
          // console.log(selecteFilters);
          // console.log(this.careerPageData.filters);
          this.careerPageData!.filters.forEach((c: any) => {
            if(c.filters) {
              c.filters.forEach((x: any) => {
                if(selecteFilters.includes(x.filterKey)) {
                  x.selected = true;
                }
              });
            }
          });
        }
        this.isLoading = false;
       
      },
      error: (e) => console.error(e),
    });
  }

  private handelUrlParameters() {
    this.route.queryParams.subscribe({
      next: (params) => {
        let page = params['page'];
        this.filters = params['filters'];
        this.term = params['term'];
        this.sorting = parseInt(params['sort']) > 0 ? parseInt(params['sort']) : this.sorting;
        let validPage = page && parseInt(page) >= 1;
        this.currentPage = validPage ? parseInt(page) : 1;

        this.getPageData();
      },
      error: (e) => console.error('Error while fetching query params', e),
    });
  }

  // Sending request to server to get filtered cards
  private getSearchResult() {
    this.isLoading = true;
    const searchRequest: SearchRequest = {
      nodeId: this.careerPageData!.nodeId,
      pageUrl: this.pageUrl ?? this.routerService.getCurrentComponentRoute(),
      cultureCode: this.dataService.getCultureCode(),
      term: this.term,
      filters: this.filters,
      pageNumber: this.currentPage,
      sorting: this.sorting
    };

    this.dataService
      .getPortalCardSearchResult(
        environment.apiUrl + '/Portal/Career-Api/GetPortalSearchResult',
        searchRequest
      )
      .subscribe({
        next: (res) => {       
          res = JSON.parse(res);
          this.careerPageData!.searchResults.cards = res.cards;
          this.careerPageData!.searchResults.totalSearchResultsCount = res.totalSearchResultsCount;
          this.isLoading = false;
        },
        error: (e) => {
          console.error(e);
          this.isLoading = false;
        }
      });
  }

  // Updating url parameters
  private updateUrlParameters() {
    let queryParams: any = {};
    if (this.currentPage > 1)
      queryParams.page = this.currentPage;
    if (this.term != undefined && this.term !== '')
      queryParams.term = this.term;

    if (this.filters != undefined && this.filters !== '') {
      queryParams.filters = this.filters;
    }

    if(this.sorting !== CareerPositionsSorting.UpdateDate)
      queryParams.sort = this.sorting

    queryParams = Object.keys(queryParams).length > 0 ? queryParams : null;

    var url = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: queryParams,
      })
      .toString();

    window.history.pushState({ path: url }, '', url);
  }

  openFiltersMobilePopup() {
    this.showFiltersMobileModal = true;
    this.changeSidebarMenu(false);
  }

  closeFiltersMobilePopup() {
    this.showFiltersMobileModal = false;
    this.changeSidebarMenu(true);
  }

  changeSidebarMenu(show: boolean) {
    let element = this.document.querySelector('app-sidebar');
    if(!element) return;
    if(show) {
      this.renderer.removeStyle(element, 'display');
    } else {
      this.renderer.setStyle(element, 'display', 'none');
    }
  }

  getFiltersEnableStatus(): boolean {
    return !(this.filters != undefined && this.filters != '');
  }

  clearFilters(event?: any) {
    if(event) event.preventDefault();

    if(this.filters && this.careerPageData!.filters.length) {
      this.careerPageData!.filters.forEach((c: any) => {
        if(c.filters) {
          c.filters.forEach((x: any) => {
            x.selected = false;
          });
        }
      });
    }

    this.filters = undefined;

    this.expansionComponents.forEach(c => {
      c.clearFilter();
    });

    this.currentPage = 1;
    this.updateUrlParameters();
    this.getSearchResult();
  }

  clearAllParams() {
    this.term = '';
    this.searchFieldComponent?.clearInput();
    this.clearFilters();
  }
}
